import { Box, CircularProgress, useTheme } from '@mui/material';
import { useGetResourceById, useUpdateResource } from '_api';
import { Resource, ResourcePayload } from '_api/types';
import { AdminRouteMap } from '_constants';
import { SEVERITY } from '_constants/derived';
import { FormHeaderText, TextButton } from 'components/atoms';
import { AlertMessage } from 'components/molecules';
import { ResourceForm } from 'components/organisms/forms';
import React, { useEffect, useMemo, useState } from 'react';
import { IoArrowBackOutline } from 'react-icons/io5';
import { useParams } from 'react-router-dom';
import { useNavigateTo } from 'utils';

export const EditResource = () => {
  const navigate = useNavigateTo();
  const theme = useTheme();
  const { resourceId: id } = useParams();
  const resourceId = useMemo(() => (id !== undefined ? Number(id) : 0), [id]);
  const { data: apiResource, isLoading } = useGetResourceById(resourceId);
  const { mutateAsync: updateExercise } = useUpdateResource();

  const convertToExercisePayload = (initResource: Resource) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { createDate, fullImageUrl, ...res } = initResource;
    return {
      ...res,
    } as ResourcePayload;
  };

  const [errorMessage, setErrorMessage] = useState('');
  const [showSuccess, setShowSuccess] = useState(false);
  const [resource, setResource] = useState<ResourcePayload | undefined>(
    apiResource ? convertToExercisePayload(apiResource) : undefined,
  );

  useEffect(() => {
    if (id && apiResource) setResource(convertToExercisePayload(apiResource));
  }, [apiResource, id]);

  const onBack = () => {
    history.back();
  };

  const onSubmit = (updatedExercise: ResourcePayload) => {
    updateExercise(updatedExercise)
      .then((data) => {
        if (data && data.id) {
          setShowSuccess(true);
          setTimeout(() => {
            navigate(AdminRouteMap.LIBRARY);
          }, 1500);
        }
      })
      .catch((error) => {
        if (error.response && error.response.status === 403) {
          setErrorMessage(
            'Unexpected error occured. Please refresh the page and try again.',
          );
        } else if (error.message) {
          setErrorMessage(`ERROR: ${error.message}`);
        } else {
          setErrorMessage('Unexpected error. Please Try again.');
        }
      });
  };

  return (
    <Box>
      <Box>
        <FormHeaderText gutterBottom> Edit Resource </FormHeaderText>
        <TextButton
          onClick={onBack}
          sx={{ color: theme.palette.primary.main, marginBottom: '10px', paddingLeft: 0 }}
        >
          <IoArrowBackOutline />
          BACK
        </TextButton>
      </Box>
      {!isLoading && resource && resource.id === resourceId ? (
        <Box>
          <ResourceForm
            disableAll={showSuccess}
            initValue={resource}
            onBack={onBack}
            onSubmit={onSubmit}
          />
        </Box>
      ) : (
        <CircularProgress />
      )}
      <AlertMessage
        open={showSuccess}
        onClose={() => setShowSuccess(false)}
        message={'Resource successfully edited'}
      />
      <AlertMessage
        open={!!errorMessage}
        onClose={() => setErrorMessage('')}
        severity={SEVERITY.error}
        message={errorMessage}
      />
    </Box>
  );
};
